import { mergeStyleSets } from "@fluentui/react";

export const useStyles = () => mergeStyleSets({
  options: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 0',
    gap: '12px',
  },
})
